import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useClinicContext } from './useClinicContext';
import { useClinicPortalServiceType } from './clinicPortalServiceType';
import { fetchCheckinMailList } from '@/services/main/checkInMain/checkinMailService';
import useAppToast from '@/hooks/useAppToast';
import { getApiErrorMessage, DEFAULT_FETCH_ERROR_MESSAGE } from '@/utils/apiError';

export const useCheckinMailList = (patientId?: string) => {
  const { tenant, clinicNumber } = useClinicContext();
  const serviceType = useClinicPortalServiceType();
  const toast = useAppToast();

  const siteType = tenant;

  const { data, isLoading, isFetching, isError, isPending, refetch, error } = useQuery({
    queryKey: ['checkin-mails', 'list', siteType, clinicNumber, patientId, serviceType],
    queryFn: async () => {
      if (!siteType || !clinicNumber || !patientId) {
        return { patient: null, list: [] };
      }
      return fetchCheckinMailList(siteType, clinicNumber, patientId);
    },
    enabled: !!siteType && !!clinicNumber && !!patientId,
    staleTime: 30_000,
  });

  useEffect(() => {
    if (isError && error) {
      toast.error(getApiErrorMessage(error, DEFAULT_FETCH_ERROR_MESSAGE));
    }
  }, [isError, error, toast]);

  return { data, isLoading, isFetching, isError, isPending, refetch, error };
};

export default useCheckinMailList;

